<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel">
                        <h2>{{tituloDaEtapaAtual}}</h2>
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <mat-divider fxFlex="1 0"></mat-divider>
                </div>
                <div *ngIf="usuarioLogado.username" class="text-danger" style="margin-top: 5px; margin-bottom: 5px;">
                    Atendente Logado: {{usuarioLogado.username}}
                </div>
                <form [formGroup]="formularioDeSelecaoDeConsulta" (ngSubmit)="onSubmit()"
                    (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>
                    <div class="panel-heading custom-sub-panel">
                        <div class="titulo-sub-painel">
                            <h3>Seleção da Consulta</h3>
                        </div>
                    </div>
                    <div class="form-row" style="margin-top: 10px;">
                        <div class="form-group col-md-12">
                            <mat-form-field appearance="fill" class="col-md-12">
                                <mat-label>Selecione a Consulta</mat-label>
                                <mat-select formControlName="procedimentoConsulta" name="procedimentoConsulta"
                                    (selectionChange)="onChangeConsulta($event)">
                                    <mat-option *ngFor="let procedimentoConsulta of listaDeProcedimentoConsulta"
                                        [value]="procedimentoConsulta">
                                        {{procedimentoConsulta.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeSelecaoDeConsulta.controls.procedimentoConsulta.hasError('required')">
                                    O campo Consulta é obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-row" *ngIf="isMarcacaoInternaMarqueExames()">
                        <div class="form-group col-md-12">
                            <mat-form-field appearance="fill" class="col-md-12">
                                <mat-label>Médico que Solicitou a Consulta</mat-label>
                                <mat-select formControlName="medicoSolicitante" name="medicoSolicitante"
                                    (selectionChange)="onChangeMedicoSolicitante($event)">
                                    <mat-option *ngFor="let medicoSolicitante of listaDeMedicosSolicitante"
                                        [value]="medicoSolicitante">
                                        {{medicoSolicitante.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="formularioDeSelecaoDeConsulta.controls.medicoSolicitante.hasError('required')">
                                    O campo Médico Solicitante é obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <mat-form-field appearance="fill" class="col-md-12">
                                <mat-label>Selecione o Local do Atendimento</mat-label>
                                <mat-select formControlName="filial" name="filial"
                                    (selectionChange)="onChangeFilial($event)">
                                    <mat-option *ngFor="let filial of listaDeFiliais" [value]="filial">
                                        {{filial.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="formularioDeSelecaoDeConsulta.controls.filial.hasError('required')">
                                    O campo Filial é obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <mat-form-field appearance="fill" class="col-md-12">
                                <mat-label>Selecione o Médico</mat-label>
                                <mat-select formControlName="medico" name="medico"
                                    (selectionChange)="onChangeMedico($event)">
                                    <mat-option *ngFor="let medico of listaDeMedicos" [value]="medico">
                                        {{medico.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="formularioDeSelecaoDeConsulta.controls.medico.hasError('required')">
                                    O campo Médico é obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-lg-4 col-md-6 col-sm-6 col-12">
                            <mat-form-field appearance="fill" class="col-md-12">
                                <mat-label>Data da Marcação</mat-label>
                                <mat-select formControlName="dataMarcacao" name="dataMarcacao"
                                    (selectionChange)="onChangeDataConsulta($event)">
                                    <mat-option *ngFor="let dataMarcacao of marcacaoConsulta.listaDatasDisponiveis"
                                        [value]="dataMarcacao">
                                        {{ dataMarcacao.data | date:"dd/MM/yyyy" }}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeSelecaoDeConsulta.controls.dataMarcacao.hasError('required')">
                                    O campo Data da Marcação é obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-group col-lg-4 col-md-6 col-sm-6 col-12">
                            <mat-form-field appearance="fill" class="col-md-12">
                                <mat-label>Hora da Marcação</mat-label>
                                <mat-select formControlName="horaMarcacao" name="horaMarcacao"
                                    (selectionChange)="onChangeHoraConsulta($event)">
                                    <mat-option *ngFor="let horaMarcacao of listaHorarios" [value]="horaMarcacao">
                                        {{ horaFormatada(horaMarcacao) }}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeSelecaoDeConsulta.controls.horaMarcacao.hasError('required')">
                                    O campo Hora da Marcação é obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="form-row" style="margin-left: 10px; margin-right: 10px;">
                        <div class="form-group botao-marcacao-esquerda col-12 col-sm-6 col-md-6 col-lg-6">
                            <button type="button" (click)="telaAnterior()" mat-raised-button color="warn"
                                matTooltip="Tela Anterior" style="margin-bottom: 10px;" class="mat-button-marcacao">
                                <mat-icon>arrow_left</mat-icon>
                                Tela Anterior
                            </button>
                        </div>
                        <div class="form-group botao-marcacao-direita col-12 col-sm-6 col-md-6 col-lg-6">
                            <button mat-raised-button color="primary" type="submit" matTooltip="Continuar Marcação"
                                [disabled]="!formularioDeSelecaoDeConsulta.valid" class="mat-button-marcacao">
                                Finalizar Marcação
                                <mat-icon>arrow_right</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>